import Media from 'react-responsive';

import { Ticker24hrChangePercent } from 'components/Header/partials';
import { DOLLAR_SIGN_FOR_INDIAN_EXCHANGE } from 'constants/constants';
import { device } from 'helpers/screenSizes';
import subscribe from 'HOC/subscribe';
import useChangeTitle from 'hooks/useChangeTitle';
import {
  lastTradePriceMovementSelector,
  lastTradePriceSelector,
} from 'selectors/priceSelectors';
import { FontAwesomeArrowDown } from 'styles/assets/icons';

import styles from './index.module.scss';

const SelectedProductLastPrice = subscribe(({ contractType }) => {
  const price = lastTradePriceSelector();
  const lastTradePriceMovement = lastTradePriceMovementSelector();

  const priceWithCurrency = price ? DOLLAR_SIGN_FOR_INDIAN_EXCHANGE + price : '-';

  useChangeTitle(price, lastTradePriceMovement);

  return (
    (<div
      className={styles['last-price-container']}
      id="ltp-box"
      data-palette="SelectedProductLastPrice">
      <div>
        <span className={styles[lastTradePriceMovement]}>{priceWithCurrency}</span>
        <FontAwesomeArrowDown className={styles[lastTradePriceMovement]} />
      </div>
      <Media query={device.down.md}>
        <div>
          <Ticker24hrChangePercent contract_type={contractType} />
        </div>
      </Media>
    </div>)
  );
});
export default SelectedProductLastPrice;
